<ol class="Breadcrumb">
  @for (item of option.breadcrumb; track item) {
    <li ngClass={{item.itemclass}}>
      <a ngClass={{item.linkclass}} routerLink={{item.link}} routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [class.disabled]="item.link === hash">
        {{item.label}}
      </a>
    </li>
  }
  @if (option.dropdowns !== undefined) {
    <li>
      <mat-select [(value)]="selected" (selectionChange)="itemchange($event)">
        @for (item of option.dropdowns; track item) {
          <mat-option [value]="[item.value]" [disabled]="item.value === selected">
            <a routerLink={{item.value}}>
              {{item.text}}
            </a>
          </mat-option>
        }
      </mat-select>
    </li>
  }
</ol>